import { Ifo } from './types'

const ifos: Ifo[] = [
  // {
  //   id: 'allin',
  //   logo: '/images/ifos/allin/logo.png',
  //   backgroundImg: '/images/ifos/allin/header.png',
  //   address: '0x046f8a448b6d521f1bbbe470aa6c4c6c4bd0f630',
  //   isActive: true,
  //   name: 'ALLin (ALLIN)',
  //   subTitle: 'ALL IN or nothing!',
  //   description: '',
  //   launchDate: '2 July 2021',
  //   launchTime: '4PM UTC', // '5PM CET',
  //   presalePrice: '3T / BNB',
  //   listingPrice: '3T / BNB',
  //   raiseAmount: '150T ALLIN (15 %)',
  //   toBurn: '300T ALLIN (30 %)',
  //   projectSiteUrl: 'https://allin.money/',
  //   currency: 'ALLinToken',
  //   currencyAddress: '0xaeDDaB73b6f73Eaacec35C1DC42C614629554FFc',
  //   tokenDecimals: 9,
  //   tokenSymbol: 'ALLIN',
  //   releaseBlockNumber: 8693081, // 8925250 (tuesday 4 p.m. UTC)
  //   campaignId: '511080002',
  // },
  {
    id: 'cshield',
    logo: '/images/ifos/covishield/logo.jpg',
    backgroundImg: '/images/ifos/covishield/header.jpg',
    address: '0x6741A312572b12718D6E869aC19817627a4f5bd6',
    isActive: true,
    name: 'CoviShield (CSHIELD)',
    subTitle: 'A shield for your loved ones.',
    description: '',
    launchDate: '22 July 2021',
    launchTime: '4PM UTC', 
    presalePrice: '888.88b / BNB',
    listingPrice: '888.88b / BNB',
    raiseAmount: '133.33T CSHIELD (15 %)',
    toBurn: '266.66T CSHIELD (30 %), daily 10M',
    projectSiteUrl: 'https://covishield.life/',
    currency: 'CoviShield',
    currencyAddress: '0x247668A8e57B7F8A00D316faF1f883971dB4AD40',
    tokenDecimals: 9,
    tokenSymbol: 'CSHIELD',
    releaseBlockNumber: 9295455, 
    campaignId: '511080099',
  },
  {
    id: 'eqt',
    logo: '/images/ifos/equitas/logo.png',
    backgroundImg: '/images/ifos/equitas/header.png',
    address: '0x6a3c489f57e032795b1c6633588ff3f05ca28088',
    isActive: false,
    name: 'Equitas Initiative (EQT)',
    subTitle: 'A world where global social, racial, and environmental inequality is balanced!',
    description: '',
    launchDate: '6 July 2021',
    launchTime: '4PM UTC', // '5PM CET',
    presalePrice: '3T / BNB',
    listingPrice: '3T / BNB',
    raiseAmount: '150T EQT (15 %)',
    toBurn: '300T EQT (30 %)',
    projectSiteUrl: 'https://www.equitasinitiative.com/',
    currency: 'EquitasToken',
    currencyAddress: '0x180bDdD32C38632751bf40af484268e430BCe7D8',
    tokenDecimals: 9,
    tokenSymbol: 'EQT',
    releaseBlockNumber: 8693081, // 8925250 (tuesday 4 p.m. UTC)
    campaignId: '511080003',
  },
  {
    id: 'lps',
    logo: '/images/ifos/lapis/logo.svg',
    backgroundImg: '/images/ifos/lapis/header.png',
    address: '0x046f8a448b6d521f1bbbe470aa6c4c6c4bd0f630',
    isActive: false,
    name: 'Lapis Token (LPS)',
    subTitle: 'Efficient NFTs and DeFi.',
    description: '',
    launchDate: '12 June 2021',
    launchTime: '6PM UTC', // '5PM CET',
    presalePrice: '3T / BNB',
    listingPrice: '~3.1T / BNB',
    raiseAmount: '150T LPS (15 %)',
    toBurn: '300T LPS (30 %)',
    projectSiteUrl: 'https://www.lapis.gallery/',
    currency: 'LapisToken',
    currencyAddress: '0x698bF4f7e3aFe0A1764C545cE005A269E4C20EaA',
    tokenDecimals: 9,
    tokenSymbol: 'LPS',
    releaseBlockNumber: 8235402,
    campaignId: '511080000',
  },
  // {
  //   id: 'watch',
  //   address: '0x55344b55C71Ad8834C397E6e08dF5195cF84fe6d',
  //   isActive: false,
  //   name: 'Yieldwatch (WATCH)',
  //   subTitle: 'A smart yield farming dashboard on BSC',
  //   description:
  //     'Yieldwatch is a smart yield farming dashboard on Binance Smart Chain that lets you monitor your liquidity pools, yield farming and token staking performance with fast and casual UI. The $WATCH token is a membership token, which is required to access advanced PRO features.',
  //   launchDate: 'Mar. 4',
  //   launchTime: '5PM SGT',
  //   saleAmount: '8,000,000 WATCH',
  //   raiseAmount: '$800,000',
  //   cakeToBurn: '$400,000',
  //   projectSiteUrl: 'https://yieldwatch.net/',
  //   currency: 'CAKE-BNB LP',
  //   currencyAddress: '0xA527a61703D82139F8a06Bc30097cC9CAA2df5A6',
  //   tokenDecimals: 18,
  //   tokenSymbol: 'WATCH',
  //   releaseBlockNumber: 5294924,
  //   campaignId: '511070000',
  // },
  // {
  //   id: 'berry',
  //   address: '0x5d028cE3435B2bB9AceBfaC599EEbA1ccD63d7dd',
  //   isActive: false,
  //   name: 'Berry (BRY)',
  //   subTitle: 'A decentralized oracle network on BSC',
  //   description:
  //     'Berry Data is a transparent community-veriﬁed price oracle on BSC. Berry Data provides a trustless and decentralized alternative for off-chain data. As the governance token for Berry Data, BRY allows holders to pay for Berry Data feeds, vote on governance issues, validate data through staking, and build the Berry ecosystem.',
  //   launchDate: 'Feb. 16',
  //   launchTime: '5PM SGT',
  //   saleAmount: '2,000,000 BRY',
  //   raiseAmount: '$1,000,000',
  //   cakeToBurn: '$500,000',
  //   projectSiteUrl: 'https://berrydata.co/',
  //   currency: 'CAKE-BNB LP',
  //   currencyAddress: '0xA527a61703D82139F8a06Bc30097cC9CAA2df5A6',
  //   tokenDecimals: 18,
  //   tokenSymbol: 'BRY',
  //   releaseBlockNumber: 4750968,
  //   campaignId: '511060000',
  // },
  // {
  //   id: 'soteria',
  //   address: '0x9C21123D94b93361a29B2C2EFB3d5CD8B17e0A9e',
  //   isActive: false,
  //   name: 'Soteria (wSOTE)',
  //   subTitle: 'A blockchain based mutual to share the risk of DeFi on Binance Smart Chain',
  //   description:
  //     'Soteria allows users to buy insurance cover to greatly diminish or reduce the financial risk of hacks. It replaces the idea of a traditional insurance company, because it is wholly owned by the members. The model encourages engagement as members receive economic incentives for participating in Risk Assessment, Claims Assessment and Governance.',
  //   launchDate: 'Jan. 21',
  //   launchTime: '4PM SGT',
  //   saleAmount: '1,500,000 wSOTE',
  //   raiseAmount: '$525,000',
  //   cakeToBurn: '$262,500',
  //   projectSiteUrl: 'https://soteria.finance/#/',
  //   currency: 'CAKE-BNB LP',
  //   currencyAddress: '0xA527a61703D82139F8a06Bc30097cC9CAA2df5A6',
  //   tokenDecimals: 18,
  //   tokenSymbol: 'wSOTE',
  //   releaseBlockNumber: 4086064,
  //   campaignId: '511050000',
  // },
  // {
  //   id: 'helmet',
  //   address: '0xa32509d760ee47Eb2Be96D338b5d69B5FBa4eFEB',
  //   isActive: false,
  //   name: 'Helmet.insure (Helmet)',
  //   subTitle: 'Crypto-assets insurance trading platform',
  //   description:
  //     'Helmet is a peer-to-peer insurance protocol written with options trading logic, which allows anyone to create any insurance policy easily in the market. Helmet aims to enable DeFi users to be protected against the risk of price fluctuations by providing price-shield insurance for BSC assets. They provide suppliers with a range of insurance types to sell, giving a variety of hedging strategies to the market.',
  //   launchDate: 'Jan. 13',
  //   launchTime: '5PM SGT',
  //   saleAmount: '10,000,000 Helmet',
  //   raiseAmount: '$1,000,000',
  //   cakeToBurn: '$500,000',
  //   projectSiteUrl: 'https://www.helmet.insure/',
  //   currency: 'CAKE-BNB LP',
  //   currencyAddress: '0xA527a61703D82139F8a06Bc30097cC9CAA2df5A6',
  //   tokenDecimals: 18,
  //   tokenSymbol: 'Helmet',
  //   releaseBlockNumber: 3771926,
  //   campaignId: '511040000',
  // },
  // {
  //   id: 'tenet',
  //   address: '0xB922aA19A2603A07C6C9ED6c236618C9bac51f06',
  //   isActive: false,
  //   name: 'Tenet (TEN)',
  //   subTitle: 'Cross-chain Automated Market Maker',
  //   description:
  //     'Tenet is a cross-chain Automated Market Maker (AMM) connector that provides a decentralized Liquidity Tap for various tokens. The Liquidity Tap is the powerhouse of the Liquidity Pool, employing a dynamic algorithm to give the Liquidity Provider fairer, more efficient, and richer incentives. Tenet aims to build a cross-chain and cross-platform toolkit protocol that allows the demand side to customize the parameters of the liquidity tap, allowing them to reach out to more liquidity participants effectively and with relative ease.',
  //   launchDate: 'Jan. 5',
  //   launchTime: '3PM SGT',
  //   saleAmount: '1,000,000 TEN',
  //   raiseAmount: '$1,000,000',
  //   cakeToBurn: '$500,000',
  //   projectSiteUrl: 'https://www.tenet.farm/',
  //   currency: 'CAKE-BNB LP',
  //   currencyAddress: '0xA527a61703D82139F8a06Bc30097cC9CAA2df5A6',
  //   tokenDecimals: 18,
  //   tokenSymbol: 'TEN',
  //   releaseBlockNumber: 3483883,
  //   campaignId: '511030000',
  // },
  // {
  //   id: 'ditto',
  //   address: '0x570c9eB19553526Fb35895a531928E19C7D20788',
  //   isActive: false,
  //   name: 'Ditto (DITTO)',
  //   subTitle: 'Next-gen elastic supply token',
  //   description:
  //     'Ditto is the first elastic supply token on the Binance Smart Chain. Its goal is to maintain a stable price of $1, where its supply will adapt to changes in demand. All supply changes will apply equally to every wallet holding Ditto, and holders should always have the same % of the total supply',
  //   launchDate: 'Dec. 23',
  //   launchTime: '3PM SGT',
  //   saleAmount: '700,000 DITTO',
  //   raiseAmount: '$630,000',
  //   cakeToBurn: '$315,000',
  //   projectSiteUrl: 'https://ditto.money/',
  //   currency: 'CAKE-BNB LP',
  //   currencyAddress: '0xA527a61703D82139F8a06Bc30097cC9CAA2df5A6',
  //   tokenDecimals: 9,
  //   tokenSymbol: 'DITTO',
  //   releaseBlockNumber: 3279767,
  //   campaignId: '511020000',
  // },
  // {
  //   id: 'blink',
  //   address: '0x44a9Cc8463EC00937242b660BF65B10365d99baD',
  //   isActive: false,
  //   name: 'BLINk (BLK)',
  //   subTitle: 'Online games on BSC',
  //   description:
  //     'BLINk enables BNB holders to enjoy gaming experiences that WINk users on Tron have been enjoying for over two years.',
  //   launchDate: 'Nov. 20',
  //   launchTime: '9PM SGT',
  //   saleAmount: '100,000,000 BLINK',
  //   raiseAmount: '$1,000,000',
  //   cakeToBurn: '$500,000',
  //   projectSiteUrl: 'https://blink.wink.org',
  //   currency: 'CAKE-BNB LP',
  //   currencyAddress: '0xA527a61703D82139F8a06Bc30097cC9CAA2df5A6',
  //   tokenDecimals: 6,
  //   tokenSymbol: 'blink',
  //   releaseBlockNumber: 3279767,
  //   campaignId: '511010000',
  // },
]

export default ifos
